import { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import { Redirect, 
    // useNavigate 
    useLocation
  } from 'react-router-dom';

  // useNavigate 
import { Helmet } from 'react-helmet';
import {
  Typography,
} from '@material-ui/core';


//My Components
import FloatingBtn from '../components/NewLogin/floatingBtns';
import RadioInput from '../components/NewLogin/RadioInput';
import AddMobile from '../components/NewLogin/AddMobile';
import ForgotPin from 'src/materials/ForgotPin';

//Redux
import { login } from "../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      height: '100%',
      paddingTop: 50,
      backgroundColor: '#BCCAE0',
      display: 'flex',
      alignItems: 'center',
    //   justifyContent: 'center',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        paddingTop: 30,
    },
    },
    touchPadWrapper: {
        width: '100%',
        height: 'auto',
        margin: 'auto',
        marginTop: theme.spacing(-3),

    },
    name: {
       margin: theme.spacing(3),
       [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },

    },
    logoWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
          paddingTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1),
        },
    },
    logo: {
       margin: 'auto'
    },
    footer: {
        position: 'absolute',
          bottom: theme.spacing(2)
    }
  })
  );

const Login = (props) => {
    const classes = useStyles();
    let { search } = useLocation();
    let nmbr = localStorage.phone;


  const [values, setValues] = useState({
    phone: null,
    password: ''
  })
  const dispatch = useDispatch();
const { isLoggedIn, user } = useSelector(state => state.auth);
const { loading, errors } = useSelector(state => state.ui);


    const handleClick = (e) => {
        let str = values.password;



        if(e !== 'x' && String(str).length <= 3 && e !== 'a'){
           let ns = str + e;
           setValues({...values, password: ns});
        } 

        if(e === 'x'){
            let ns = str.substring(0, str.length - 1);
            return setValues({...values, password: ns});
        }
        if(String(str).length === 3){
          values.password = str + e;
          return handleLogin(values)

      }
   
    }


const handleLogin = (val) => {

  dispatch(login(val))
  .then(rs => {
    setValues({...values, password: ''})
  })
  .catch(err => {
    setValues({...values, password: ''})
    console.log(err)
  })

} 



useEffect(() => {
  var uri = window.location.toString();
  if (uri.indexOf("?") > 0) {
      let pr = search.split("?")[1];
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);
      localStorage.setItem('phone', pr);
      setValues({...values, phone: pr})
  }
}, [])

const handleSetPhone = (e) => {
  setValues({...values, phone: e})
  localStorage.setItem('phone', e);
}

useEffect(() => {
  if(nmbr){
    setValues({...values, phone: nmbr})
  }
}, [nmbr])

if (isLoggedIn && user) {
  return <Redirect to="/app/dashboard" />;
}
  return (
    <div className={classes.root}>
      <Helmet>
        <title>Transac | Login
          </title>
      </Helmet>
      <div
         className={classes.touchPadWrapper}
      >     
          <div className={classes.name}>
          <div className={classes.logoWrapper}>
          <img 
            className="text-center"
            src="/static/Tlogo1.png"
            height="50px"
            width="auto"

            />
    </div>
       
          <Typography className="text-center" variant="h4">{ values.phone ? `(+63) ${values.phone}` : 'Transactors Mobile'}</Typography>
      <AddMobile handleChange={handleSetPhone} />
          </div>
         <RadioInput pin={values.password}/>
          <FloatingBtn handleClick={handleClick}/>
          <div className="center-element">
              <ForgotPin/>
          </div>
      </div>     
    </div>
  );
};

export default Login;
